import React, { useEffect } from "react";
//outsource
import { Select } from "antd";

//components

//redux
import { useDispatch, useSelector } from "react-redux";

import { setUser } from "../../../../store/report/report.action";

import { branchsSelector } from "../../../../store/branch/branch.selector";
import { company } from "../../../../store/report/report.selector";
import { usersSelector } from "../../../../store/user/user.selector";

const TimeUserSearch = ({ userId, setUserId }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branchs = useSelector(branchsSelector);
  const branchId = useSelector(company);
  const users = useSelector(usersSelector);
  // -------------------------- FUNCTION --------------------------
  const handleChange = (value) => {
    setUserId(value);
  };

  const handleClear = () => {
    setUserId("");
  };
  // -------------------------- EFFECT --------------------------
  // useEffect(() => {
  //   dispatch(snapAllUsers());
  //   return () => dispatch(unSnapUsers());
  // }, [dispatch]);
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  const options = users ? convertData(users, branchs, branchId) : [];
  console.log({ userId });
  return (
    <Select
      style={{ width: "100%" }}
      placeholder="Search By Name.."
      allowClear
      showSearch
      // value={userId}
      options={options}
      onSelect={handleChange}
      onClear={handleClear}
      //   optionFilterProp="children"
      filterOption={(input, option) =>
        option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    />
  );
};

export default TimeUserSearch;

const convertData = (users, branchs, branchId) => {
  let target =
    branchs && branchId && branchs?.find((item) => item?.id === branchId);
  let coop = target?.coop || [];
  let filteredUser = users?.filter((u) => {
    const id = u?.id;
    const valids = coop?.includes(id);
    return valids;
  });

  const newData = filteredUser?.map((item) => {
    const label = `${item?.firstName} ${item?.lastName} (${item?.username})`;
    const value = item?.id;

    return {
      value,
      label,
    };
  });

  return newData;
};
